import { ApiUtil as api } from "@/utils/api.util.js";

export class CommentService {
  static URL = process.env.API_URL + process.env.API_VER;
  static RESOURCE = "/comments/";

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams);
  }
}



// WEBPACK FOOTER //
// ./src/services/comment.service.js